import React from 'react';

import PropTypes from 'prop-types';

import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import { parseDate } from '@adsk/alloy-react-datetime';

import MaintenancePage from './MaintenancePage';

const normalizeDate = (date) => {
  try {
    return date ? (date instanceof Date ? date : parseDate(date)) : undefined;
  } catch (e) {
    return null;
  }
};

const MaintenancePageConditionalRenderer = ({ children, onLogout }) => {
  const { value: showMaintenancePage } = useAlloyFeatureFlag(
    'show-maintenance-page'
  );
  const { value: maintenancePageEndDate } = useAlloyFeatureFlag(
    'maintenance-page-end-date'
  );
  if (showMaintenancePage) {
    const parsedEndDate = maintenancePageEndDate
      ? normalizeDate(maintenancePageEndDate)
      : null;
    return <MaintenancePage onLogout={onLogout} endDate={parsedEndDate} />;
  }
  return children;
};

MaintenancePageConditionalRenderer.displayName =
  'MaintenancePageConditionalRenderer';

MaintenancePageConditionalRenderer.propTypes = {
  /** The content to show if user has access */
  children: PropTypes.node,
  /** callback called on logout */
  onLogout: PropTypes.func,
};

export default MaintenancePageConditionalRenderer;
